import { useEffect, useState } from 'react';

type UseLoginSliderCycleOptions = {
  slideCount: number;
  intervalMs?: number;
  fadeMs?: number;
};

export const useLoginSliderCycle = ({
  slideCount,
  intervalMs = 4000,
  fadeMs = 180,
}: UseLoginSliderCycleOptions) => {
  const [idx, setIdx] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % slideCount);
        setAnimKey((k) => k + 1);
        setVisible(true);
      }, fadeMs);
    }, intervalMs);

    return () => clearTimeout(timer);
  }, [idx, slideCount, intervalMs, fadeMs]);

  const go = (i: number) => {
    setVisible(false);
    setTimeout(() => {
      setIdx(i);
      setAnimKey((k) => k + 1);
      setVisible(true);
    }, fadeMs);
  };

  return { idx, visible, animKey, go };
};
